export const mapToOptionsFiltered = <
  T extends { id: number } & Partial<{ name: string; destination: string }>,
>(
  data?: { items: T[] | null } | null,
  filter?: number,
  mapper?: (item: T) => { id: number; label: unknown },
): { id: number; label: string }[] => {
  if (!data?.items) return [];

  const seen = new Set<string>();

  return data.items
    .filter((item) => item.id !== filter)
    .map((item) =>
      mapper
        ? mapper(item)
        : {
            id: item.id,
            label: item.name ?? item.destination ?? String(item.id),
          },
    )
    .filter((option): option is { id: number; label: string } => {
      if (!option || option.label == null) return false;

      const label = String(option.label).trim();
      if (!label) return false;

      if (seen.has(label)) return false;
      seen.add(label);

      return true;
    });
};
